import { css } from '@emotion/css'
import { spacing, borderRadius, fontFamily, fontSize, fontWeight } from '../../../styles'
import getThemeColors, { colors } from '../../../themes'
import { hexToRgba } from '../../../themes/helpers'

const styles = {
  box: css({
    cursor: 'pointer',
    position: 'relative',
    padding: spacing.default,
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    color: colors.jumbo,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  }),

  input: css({
    position: 'absolute',
    width: '100%',
    height: '100%',
    appearance: 'none',
    margin: 0,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: -1,

    '&:focus': {
      outline: 'none',
    },
  }),
}

export default styles

export const inputTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:checked': {
      borderColor: themed.base,
      backgroundColor: themed.light,

      '& + *': {
        color: themed.base,
      },
    },

    '&:hover': {
      borderColor: themed.base,

      '& + *': {
        color: themed.base,
      },
    },

    '&:focus': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.medium, 0.25)}`,

      '& + *': {
        color: themed.base,
      },
    },
  })
}
